<!--<div #wrap [class.invisible]="isLoggedIn||isUserLoggedIn">-->
<div #wrap>
    <ig-drop-down #popup
                  showDropDownItem="true" (onDropdownShow)="dropdownShow()">
        <ig-drop-down-trigger [useDiv]="false" [text]="text">
        </ig-drop-down-trigger>
        <div items>
            <ig-drop-down-item>
                <ig-fb-login-btn #fb [customize]="true" (onLoginStatusChanged)="loginStatusChanged($event)">
                    <!--<div class="login-wrap">-->
                    <!--<div class="social-logo">f</div>-->
                    <!--<div class="login-text">Sign In with Facebook</div>-->
                    <!--</div>-->
                    <div class="flex login-wrap" style="background-color: #3b6dac;">
                        <img [src]="fbLogo" alt="facebook logo"
                             style="margin-right: 10px;border-radius: 4px;width:24px;height:24px;">
                        <div class="login-text">Sign In with Facebook</div>
                    </div>
                </ig-fb-login-btn>
            </ig-drop-down-item>
            <ig-drop-down-item>
                <ig-google-login-btn #google (onLoginStatusChanged)="loginStatusChanged($event)">
                    <!--<div class="login-wrap" style="background-color: #e15f4b;">-->
                    <!--<div googleIcon class="social-logo">G+</div>-->
                    <!--<div google class="login-text">Sign In with Google+</div>-->
                    <!--</div>-->
                    <!--                    <div class="flex login-wrap" style="background-color: #41abf3;">-->
                    <!--                        <img [src]="googleLogo" alt=""-->
                    <!--                             style="margin-right: 10px;border-radius: 4px;width:32px;height:32px;">-->
                    <!--                        <div class="login-text">Sign In with Google</div>-->
                    <!--                    </div>-->

                    <div id="google-signin-btn"></div>
                </ig-google-login-btn>
            </ig-drop-down-item>
        </div>
    </ig-drop-down>
</div>


<mat-menu #actionMenu="matMenu">
    <button type="button" mat-menu-item (click)="logout()">Logout</button>
</mat-menu>

<!--<img #profileImg *ngIf="isLoggedIn||isUserLoggedIn" [matMenuTriggerFor]="actionMenu" [src]="img">-->
<img socialProfile #profileImg [matMenuTriggerFor]="actionMenu" [src]="img" alt="user profile picture"
     style="display: none">



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/social.login.popup/social.login.popup.component.html